import * as React from 'react';

import * as styles from './Heading.scss';

export interface OwnProps {
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  children?: React.ReactNode;
}

export function Heading({element: Element = 'h2', children}: OwnProps) {
  return <Element className={styles.Heading}>{children}</Element>;
}
